import Vue from 'vue'
import Vuex from 'vuex'

import * as firebase from '@/services/firebase'

Vue.use(Vuex)

export default {
  namespaced: true,
  state: {
    topics: [],
    topicsLoaded: false,
  },
  mutations: {
    SET_STATE(state, payload) {
      Object.assign(state, {
        ...payload,
      })
    },
  },
  actions: {
    async getTopics({ commit }) {
      console.log('Loading topics')
      const topics = []
      await firebase.firebaseFirestore
        .collection('topics')
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            topics.push(doc.data())
          })
          commit('SET_STATE', {
            topics,
            topicsLoaded: true,
          })
          console.log('Topics loaded into state')
        })
        .catch(err => console.log(err))
    },
  },
  getters: {
    content: state => state,
  },
}
